"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAllToSet = exports.addAllToMap = exports.uniqueBy = exports.unique = void 0;
function unique(items) {
    return [...new Set(items)];
}
exports.unique = unique;
function uniqueBy(items, keyFn) {
    const map = new Map(items.map((it) => [keyFn(it), it]));
    return [...map.values()];
}
exports.uniqueBy = uniqueBy;
function addAllToMap(map, newValues) {
    for (const [key, value] of newValues) {
        map.set(key, value);
    }
}
exports.addAllToMap = addAllToMap;
function addAllToSet(set, newValues) {
    for (const value of newValues) {
        set.add(value);
    }
}
exports.addAllToSet = addAllToSet;
